import { render, staticRenderFns } from "./ReviewsCategoriesHeader.vue?vue&type=template&id=36ac5bbe&scoped=true&"
import script from "./ReviewsCategoriesHeader.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesHeader.vue?vue&type=style&index=0&id=36ac5bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac5bbe",
  null
  
)

export default component.exports